import { registerAllViews, renderAppShell } from "@org-avp/avp-avengers-ui-app-shell";

const rootEl = document.getElementById("root");
if (rootEl !== null && rootEl !== undefined) {
  registerAllViews().then(() => {
    renderAppShell(rootEl);
  });
}
